<form [formGroup]="form">
    <mat-form-field class="large-input-grid" appearance="outline">
        <mat-label>{{ 'product.stock.stock' | translate }} </mat-label>
        <input id="txtStockQuantity" [attr.type]="fractional ? 'text' : 'number'" matInput
            [formControlName]="controlName" (blur)="formatStockFractional()">

        <mat-error *ngIf="(!formControl_Quantity.hasError('negative') && !formControl_Quantity.hasError('maxReached') && !formControl_Quantity.errors?.['pattern']?.requiredPattern) 
             && formControl_Quantity.invalid && formControl_Quantity.touched">
            {{ 'product.stock.validationInitial' | translate }}
        </mat-error>

        <mat-error *ngIf="formControl_Quantity.errors?.['pattern']?.requiredPattern && formControl_Quantity.touched">
            {{ 'product.stock.validationPattern' | translate }}
        </mat-error>

        <mat-error *ngIf="formControl_Quantity.hasError('negative') && formControl_Quantity.touched">
            {{ 'product.stock.validationInitialNegative' | translate }}
        </mat-error>

        <mat-error *ngIf="formControl_Quantity.hasError('maxReached') && formControl_Quantity.touched">
            {{ 'product.stock.validationInitialMax' | translate }}
        </mat-error>

    </mat-form-field>
    <span class="description">{{unitDescription}}</span>
</form>